import { lazy } from 'react'

// DetailsForm pulls in validation.ts and its libphonenumber-js metadata — by far
// the heaviest part of the patient bundle. It only renders at the final step, so
// it's split out and fetched while the user is mid-flow. Render inside <Suspense>.
export const DetailsForm = lazy(() =>
  import('./DetailsForm').then((m) => ({ default: m.DetailsForm }))
)

/** Shared Suspense fallback matching the app's loading treatment. */
export function DetailsFormFallback() {
  return (
    <div className="state-block">
      <div className="spinner" aria-hidden />
      <p>Loading…</p>
    </div>
  )
}
